import { ChangeDetectionStrategy, Component, inject, model, OnDestroy, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ListService } from '../../services';
import { BaseComponent } from '../../shared';


/**
* Pagination component that handles result pages in patient and plan list.
*/
@Component({
	selector: 'pagination',
	templateUrl: './pagination.component.html',
	imports: [
		FormsModule,
		NgbPaginationModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PaginationComponent extends BaseComponent implements OnInit, OnDestroy {

	private readonly listSrv = inject(ListService);

	readonly pageSizeList = [10, 15, 20, 25, 50];
	page = signal<number>(1);
	pageSize = model<number>(this.pageSizeList[0]);
	collectionSize = signal<number>(0);
	totalPages = signal<number>(0);

	searchResultSubscription$?: Subscription;

	ngOnInit(): void {
		this.searchResultSubscription$ = this.listSrv.getSearchResultCount().subscribe(count => {
			this.collectionSize.set(count ?? 0);
			this.totalPages.set(this.pageSize() ? Math.ceil(this.collectionSize() / this.pageSize()) : 1);
		});
		this.initPagination();
	}

	private initPagination(): void {
		this.page.set(this.listSrv.getPageNumber() + 1);
		this.pageSize.set(this.listSrv.getPageSize());
	}

	/**
	* Update list according the page number selected.
	*/
	changePageNumber(page: number): void {
		this.page.set(page);
		this.listSrv.changePageNumber(page - 1);
	}

	/**
	* Update list according the page size selected.
	*/
	changePageSize(): void {
		this.page.set(1);
		this.listSrv.changePageSize(this.pageSize());
	}


	ngOnDestroy(): void {
		this.searchResultSubscription$?.unsubscribe();
	}

}